import { render } from "./PresaInCaricoModal.vue?vue&type=template&id=6a7333b6"
import script from "./PresaInCaricoModal.vue?vue&type=script&lang=js"
export * from "./PresaInCaricoModal.vue?vue&type=script&lang=js"

import "./PresaInCaricoModal.vue?vue&type=style&index=0&id=6a7333b6&lang=css"

import exportComponent from "C:\\Ecommerce\\CONAD_MANUTENZIONI\\conad-manutenzioni\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__